import {
  ControlsActions,
  DownloadActions,
  GlobalPlayerStore,
  GlobalPlayerStoreState,
  MiniActions,
  PlayerActions,
  Subscriber,
} from "../types";
import { createControlsSlice } from "./slices/controls-slice";
import { createDownloadSlice } from "./slices/download-slice";
import { createMiniPlayerSlice } from "./slices/mini-player-slice";
import { createPlayerSlice } from "./slices/player-slice";

export const DEFAULT_STATE: GlobalPlayerStoreState = {
  id: "",
  source: "",
  title: "",
  duration: 0,
  currentTime: 0,
  speed: "1",
  fileSize: 0,
  isMobile: false,
  playing: false,
  ended: false,
  isLoading: false,
  initialLessonIndex: 0,
  playerEl: null,
  analyticsTracker: undefined,
  isMini: false,
  downloadProgress: 0,
  downloadedSize: 0,
  isDownloading: false,
  isPaused: false,
  isCompleted: false,
  pendingPlayByUser: false,
  isShowingControls: false,
  showSettings: false,
  currentSkip: null,
  isFullscreen: false,
  playerWrapEl: null,
  clipMode: false,
  muted: false,
};

export const createGlobalPlayerStore = (): GlobalPlayerStore => {
  let state: GlobalPlayerStoreState = {
    ...DEFAULT_STATE,
  };
  const subscribers = new Set<Subscriber>();

  const set = (patch: Partial<GlobalPlayerStoreState>) => {
    state = {
      ...state,
      ...patch,
    };
    subscribers.forEach((cb) => cb(state));
  };

  const store: GlobalPlayerStore = {
    get: () => state,
    set,
    subscribe: (cb) => {
      subscribers.add(cb);
      return () => subscribers.delete(cb);
    },

    playerActions: {} as PlayerActions,
    miniActions: {} as MiniActions,
    downloadActions: {} as DownloadActions,
    controlsActions: {} as ControlsActions,
  };

  store.playerActions = createPlayerSlice(store);
  store.miniActions = createMiniPlayerSlice(store);
  store.downloadActions = createDownloadSlice(store);
  store.controlsActions = createControlsSlice(store);

  return store;
};
